import type {FC, ReactElement} from 'react'

import type {StepWizardChildProps} from "react-step-wizard";

const Nav: FC<Partial<StepWizardChildProps>> = ({totalSteps, currentStep}): ReactElement => {
  const dots = []

  const totalStepCount = totalSteps ?? 0

  for (let i = 1; i <= totalStepCount; i += 1) {
    const isActive = currentStep === i
    dots.push((
      <span
        key={`step-${i}`}
        className={`dot ${isActive ? 'active' : ''}`}
      >&bull;
      </span>
    ))
  }

  return (
    <div className='wizard-navi'>{dots}</div>
  )
}

export default Nav
